import { P } from 'Core/Common/Promise';
import {Deserialize, GenericDeserialize} from 'libs/cerialize';
import { SupersetSettings } from 'Pages/BI/Models/SupersetSettings';
import {URL} from 'Core/Common/Url';
import {Request} from 'Core/Common/Request';
import { Dashboard } from '../Models/Dashboard';

export class SupersetStore {

    static GetItems(): P.Promise<Array<Dashboard>> {
		let deferredResult = P.defer<Array<Dashboard>>();

		Request
		.For(URL.SUPERSET.GET_ITEMS)
		.Get()
        .fail(error=>deferredResult.reject({ message: error.message}))
		.then(data => deferredResult.resolve(Deserialize(data, Dashboard)));

        return deferredResult.promise();
    }

    static CreateDashboard(title: string): P.Promise<Dashboard> {
		let deferredResult = P.defer<Dashboard>();

		Request.Send({
			proxy: {
				url: URL.SUPERSET.CREATE_DASHBOARD,
				type: 'POST',
				contentType: 'application/json'
			},
			params: JSON.stringify({ Title: title })
		})
        .fail(error=>deferredResult.reject({ message: error.message}))
		.then(data => deferredResult.resolve(GenericDeserialize<Dashboard>(data, Dashboard)));

        return deferredResult.promise();
    }

    static GetDesignerUrl(dashboardId?: string, section?: string): P.Promise<string> {
		let deferredResult = P.defer<string>();

		Request
		.For(URL.SUPERSET.GET_DESIGNER_URL)
		.Get({ dashboardId: dashboardId || '', section: section || '' })
        .fail(error=>deferredResult.reject({ message: error.message}))
		.then(data => deferredResult.resolve(data.Url));

        return deferredResult.promise();
    }

    static Ask(message: string, history: Array<{Role: string, Content: string}>, currentDashboardId?: string, context?: {Kind: string, Id: string, Label: string}): P.Promise<any> {
		let deferredResult = P.defer<any>();

		Request.Send({
			proxy: {
				url: URL.SUPERSET.ASK,
				type: 'POST',
				contentType: 'application/json'
			},
			params: JSON.stringify({ Message: message, History: history, CurrentDashboardId: currentDashboardId || null, Context: context || null })
		})
        .fail(error=>deferredResult.reject({ message: error.message}))
		.then(data => deferredResult.resolve(data));

        return deferredResult.promise();
    }

    static GetSettings(): P.Promise<SupersetSettings> {
		let deferredResult = P.defer<SupersetSettings>();

		Request
		.For(URL.SUPERSET.GET_SETTINGS)
		.Get()
        .fail(error=>deferredResult.reject({ message: error.message}))
		.then(data => deferredResult.resolve(GenericDeserialize<SupersetSettings>(data, SupersetSettings)));

        return deferredResult.promise();
    }
}
